import { Injectable } from '@angular/core';
import { EmploymentClient, EmploymentSearchResultDto } from '@core/api';
import { FormlyFieldBaseService } from '@core/services/formly-service/formly-field.service';
import { FormlyPreviewAutocompleteProps } from '@core/services/formly-service/formly-service.types';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployeeSearchFormlyFieldService extends FormlyFieldBaseService {
  override translatePath = 'contact.autocomplete';

  constructor(
    protected override translateService: TranslateService,
    private employmentClient: EmploymentClient
  ) {
    super(translateService);
  }

  autocompleteSearch(
    placeholder: string,
    onSelect: (
      id: string,
      onInitSearch: boolean,
      value: EmploymentSearchResultDto
    ) => void,
    required?: boolean,
    visibleInConfirm?: boolean,
    currentUserEmail?: string,
    hideInPreview?: boolean,
    onDelete?: () => void,
    currentUser?: EmploymentSearchResultDto,
    tooltip?: string
  ): FormlyFieldConfig[] {
    const translatePath = 'contact.autocomplete';

    const columnDefinitions = [
      {
        fieldName: 'fullName',
        labelTranslationKey: translatePath + '.name',
        classes: 'col-3, text-overflow',
        hideInPreview: hideInPreview ?? false,
      },
      {
        fieldName: 'phone',
        labelTranslationKey: translatePath + '.phone',
        classes: 'col-2, text-overflow',
        hideInPreview: hideInPreview ?? false,
      },
      {
        fieldName: 'mobilePhone',
        labelTranslationKey: translatePath + '.mobilePhone',
        classes: 'col-2, text-overflow',
        hideInPreview: hideInPreview ?? false,
      },
      {
        fieldName: 'company',
        labelTranslationKey: translatePath + '.company',
        classes: 'col-3, text-overflow',
        hideInPreview: hideInPreview ?? false,
      },
      {
        fieldName: 'orgUnit',
        labelTranslationKey: translatePath + '.orgUnit',
        classes: 'col-2, text-overflow',
        hideInPreview: hideInPreview ?? false,
      },
    ];
    const props: FormlyPreviewAutocompleteProps = {
      bindLabel: 'fullName',
      bindValue: 'id',
      required: required,
      visibleInConfirm: visibleInConfirm ?? false,
      translatePath,
      columnDefinitions,
      defaultValue: { id: currentUserEmail },
      onSearch: (searchText: string): Observable<any> => {
        return this.employmentClient
          .searchEmployee(searchText)
          .pipe(map(x => x.entites));
      },
      onSelect,
      onDelete,
      label: this.translateService.instant(placeholder),
      currentUser,
      tooltip,
    };

    return [
      {
        type: 'preview-autocomplete',
        key: 'searchResult',
        props: { ...props },
        validation: {
          messages: {
            required: this.translateService.instant('formErrors.contact.empty'),
          },
        },
      },
    ];
  }
}
